import Drawer from "../../../components/drawers/Drawer";
import { ExternalLink, Eye } from "lucide-react";
import { useEffect, useState } from "react";
import useAPI from "../../../hooks/useAPI";

export default function MobilePreviewDrawer({ companyId, companyData }) {
  const [showOverlay, setShowOverlay] = useState(false);
  const api = useAPI();

  useEffect(() => {
    if (companyData && Object.keys(companyData).length > 0) {
      sessionStorage.setItem("previewDesignData", JSON.stringify(companyData));
    }
  }, [companyData]);

  useEffect(() => {
    api.getWalletShard()
      .then(() => setShowOverlay(false))
      .catch(() => setShowOverlay(true));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isDev = window.location.hostname.startsWith("dev-") || window.location.hostname === "localhost";
  const walletBaseUrl = isDev
    ? "https://dev-wallet.wallettwo.com"
    : "https://wallet.wallettwo.com";

  const iframeUrl = new URL(`${walletBaseUrl}/wallet/dashboard`);
  iframeUrl.searchParams.append("companyId", companyId || "");
  iframeUrl.searchParams.append("preview", "true");
  iframeUrl.searchParams.append("mobile", "true");

  return (
    <Drawer
      name="mobilePreview"
      title="Mobile preview"
      closeButton={true}
      className="bg-[#F2F2F2]"
      backgroundColor="bg-[#F2F2F2]"
      drawerWidth="sm:w-100"
    >
      <div className="h-full flex flex-col space-y-6">
        {/* Mobile Preview Section */}
        <div className="flex-1 flex items-start justify-center">
          <div
            className="relative w-full rounded-3xl bg-gray-100 shadow-lg overflow-hidden"
            style={{ aspectRatio: "9/19", maxHeight: "700px" }}
          >
            <iframe
              src={iframeUrl.toString()}
              title="Mobile Preview"
              className="w-full h-full"
              style={{
                filter: showOverlay ? "blur(6px)" : "none",
                transition: "filter 0.3s ease",
              }}
              sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
            />

            {showOverlay && (
              <div className="absolute inset-0 flex items-center justify-center bg-black/10">
                <div className="bg-white rounded-2xl shadow-xl p-6 mx-4 text-center">
                  <div className="flex justify-center mb-3">
                    <div className="bg-blue-100 rounded-full p-3">
                      <Eye className="w-5 h-5 text-blue-600" />
                    </div>
                  </div>
                  <h4 className="text-base font-semibold text-gray-900 mb-2">
                    Wallet preview
                  </h4>
                  <p className="text-xs text-gray-600 mb-5">
                    Please create your wallet to activate the preview.
                  </p>
                  <button
                    onClick={() => setShowOverlay(false)}
                    className="w-full px-4 py-2 bg-blue-600 text-white text-sm font-semibold rounded-xl hover:bg-blue-700 transition-colors cursor-pointer"
                  >
                    Confirm
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-200" />

        {/* Web View Section */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Web View</h3>
          <a
            href={`${walletBaseUrl}?companyId=${companyId}`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-4 py-2 bg-white text-black rounded-2xl font-semibold hover:bg-gray-200 transition"
          >
            <ExternalLink className="w-4 h-4" />
            Go to Web Wallet
          </a>
        </div>
      </div>
    </Drawer>
  );
}